// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"134":"chunk_layerswipe","142":"chunk_statsgrid","264":"chunk_metrics","472":"chunk_terrain-profile","855":"chunk_announcements"}[chunkId] || chunkId) + "/oskari.min.css";
};